module.exports = __webpack_public_path__ + "img/pilalitou.0101ecfe.jpg";